import EMPTY_FIELD_VALUE from '../../config/defaultValues';
import createCSVValueGetter from './createCSVValueGetter';

const dmaValueFormatter = ({ rowData: { dmaCode, dmaName }, formatOptions: { msgIdPrefix }, i18n }) =>
    i18n.formatMessage({ id: `${msgIdPrefix}.${dmaCode}`, defaultMessage: dmaName || EMPTY_FIELD_VALUE });

const dmaValueGetter = createCSVValueGetter(dmaValueFormatter);

export default dmaValueGetter;
